// TODO: remove
export function getContentType(route: string): string | undefined {
  const regexp = /\/school\/course\/.*\/(.*)\//gm
  const matches = regexp.exec(route)
  return matches?.[1]
}
